import { load } from 'recaptcha-v3';

export default defineNuxtPlugin((nuxtApp) => {
  const { googleRecaptchaKey } = useRuntimeConfig().public;

  async function recaptchaV3(action) {
    const recaptcha = await load(googleRecaptchaKey, {
      useRecaptchaNet: true,
      autoHideBadge: true,
    });

    return await recaptcha.execute(action);
  }

  nuxtApp.provide('recaptchaV3', recaptchaV3);
});
